import ImageContainer from "../../Images/ImageContainer";

export default class ImageRenderer {

    constructor(room, imageUrl) {
        this.imageObject = ImageContainer.getInstance().image(imageUrl);

        this.imageObject.load().then(() => {
            room.needsRendering = true;
        });
    }

    render(ctx, centerX, centerY, radius) {

        if (this.imageObject) {
            let imageObject = this.imageObject;
            let imageWidth;
            let imageHeight;
            let size = radius * 2

            if (imageObject.getImage().width < imageObject.getImage().height) {
                // horizontal image
                imageHeight = size;
                imageWidth = size * (imageObject.getImage().width / imageObject.getImage().height);
            } else {
                imageWidth = size;
                imageHeight = size * (imageObject.getImage().height / imageObject.getImage().width);
            }

            let imageX = (centerX - radius) - ((imageWidth - size) / 2)
            let imageY = (centerY - radius) - ((imageHeight - size) / 2)

            try {
                ctx.drawImage(imageObject.getImage(), imageX, imageY, imageWidth + 2, imageHeight + 2);
            } catch (e) {
                console.warn(e);
            }


        }
    }



}